import React from 'react';
import TemplatePage from '../../components/TemplatePage/TemplatePage';
import { biotechnologyData } from '../../data/departmentalData/biotechnology';

const Biotechnology = () => {
  return <TemplatePage data={biotechnologyData} />;
};

export default Biotechnology;
